// Unified Rupeezy event taxonomy — rupeezy-login (web-auth, JS source).
// One event pattern, one property dictionary. EVERY value is snake_case.
// The verb lives ONLY in `action` — never baked into screen/element/source values.

export const EVENTS = {
  SCREEN_VIEWED: "screen_viewed",
  ELEMENT_INTERACTION: "element_interaction",
  LOGIN_SUCCEEDED: "login_succeeded",
} as const;

export const FLOW = {
  ONBOARDING: "onboarding",
  ACCOUNT: "account",
  NAVIGATION: "navigation",
  SYSTEM: "system",
} as const;

export const ACTION = {
  TAPPED: "tapped",
  VIEWED: "viewed",
  CLICKED: "clicked",
  SUBMITTED: "submitted",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
} as const;

export const SCREEN = {
  LOGIN: "login",
  MPIN: "mpin",
  OTP: "otp",
  TOTP: "totp",
  QR_LOGIN: "qr_login",
  APPS: "apps",
  NAV: "nav",
} as const;

export const ELEMENT = {
  SWITCH_USER: "switch_user",
  TOTP_DO_LATER: "totp_do_later",
} as const;

export const SOURCE = {
  WEB: "web",
  SSO: "sso",
  TERMINAL: "terminal",
} as const;

// Property dictionary (payload shape).
export interface AnalyticsParams {
  flow?: string;
  screen?: string;
  action?: string;
  element?: string;
  status?: string;
  source?: string;
  step?: number | string;
  label?: string;
  // identity (login only)
  mobile?: string;
  identifier?: string;
  email?: string;
}

// Runtime normalizer -> always snake_case.
export function snake(v: unknown): string | undefined {
  const raw = String(v ?? "").trim();
  if (!raw) return undefined;
  return raw
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/[\s.,/-]+/g, "_")
    .toLowerCase()
    .replace(/_(tap|tapped|click|clicked|view|viewed|launch|btn|button)$/g, "")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");
}
